module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Display1-4fb8d41726c8a286d9db949f1b529ad8.svg";